import {orderBy} from 'lodash';

export const sortByOrderNo = <T>(fields: T[]): T[] => orderBy(fields, ['orderNo']);